"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Card = void 0;
var react_1 = __importDefault(require("react"));
var storybook_1 = require("@eyecons/storybook");
var prop_types_1 = __importDefault(require("prop-types"));
function Price(_a) {
    var price = _a.price, _b = _a.type, type = _b === void 0 ? 'light' : _b, _c = _a.interval, interval = _c === void 0 ? 'maand' : _c;
    return react_1.default.createElement("div", { className: "storybook-subscriptions-price-" + type },
        "\u20AC ",
        price,
        react_1.default.createElement("span", null,
            "\u00A0/ ",
            interval));
}
function Thumb(_a) {
    var plan = _a.plan, position = _a.position;
    return react_1.default.createElement("div", { className: "storybook-subscription-card-image storybook-subscription-card-image-" + position, style: { backgroundImage: "url(" + plan.thumbnail + ")" } },
        react_1.default.createElement("div", null));
}
var Card = function (_a) {
    var className = _a.className, plan = _a.plan;
    return react_1.default.createElement("div", { className: storybook_1.Helpers.classNames(className, 'storybook-subscription-card') },
        plan.thumbnail && react_1.default.createElement("div", { className: 'storybook-subscription-card-image-before' },
            react_1.default.createElement(Thumb, { plan: plan, position: 'before' })),
        react_1.default.createElement("div", { className: 'storybook-subscription-card-info' },
            react_1.default.createElement(storybook_1.Texts.Heading, { className: 'text-white', type: 'h2' }, plan.label),
            react_1.default.createElement(storybook_1.Texts.Primary, null, plan.description),
            react_1.default.createElement("div", { className: 'flex gap-4 items-center' },
                react_1.default.createElement(Price, { price: plan.year, type: 'secondary', interval: 'jaar' }),
                react_1.default.createElement(Price, { price: plan.month }))),
        react_1.default.createElement("div", { className: 'storybook-subscription-card-action' },
            plan.thumbnail && react_1.default.createElement(Thumb, { plan: plan, position: 'after' }),
            react_1.default.createElement("div", { className: 'storybook-subscription-card-subscribe' },
                react_1.default.createElement(storybook_1.Buttons.Link, { to: process.env.NEXT_PUBLIC_STORYBOOK_SITE_URL + "/subscriptions/" + plan.id + "/create", type: 'primary' }, "Abonneren"))));
};
exports.Card = Card;
exports.Card.propTypes = {
    /**
     * Add classes
     */
    className: prop_types_1.default.string,
    /**
     * Add object for subscription plans
     */
    plan: prop_types_1.default.shape({
        label: prop_types_1.default.string,
        name: prop_types_1.default.string,
        year: prop_types_1.default.number.isRequired,
        month: prop_types_1.default.number.isRequired,
    }).isRequired,
};
